import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/Navbar.css';
import DefaultModal from './modals/DefaultModal';
import useDefaultModal from './hooks/useDefaultModal';
import ChangePasswordModal from './modals/ChangePasswordModal';
import { logout } from '../api/logout';

function Navbar({ toggleSidebar }) {
  const [user, setUser] = useState(null);
  const [escola, setEscola] = useState(null);
  const [vinculo, setVinculo] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const [anoBase, setAnoBase] = useState(localStorage.getItem('ano') || new Date().getFullYear().toString());
  const [inputAno, setInputAno] = useState(new Date().getFullYear());
  const navigate = useNavigate();
  const location = useLocation();
  const storedOptions = localStorage.getItem('vinculos_all');
  const parsedOptions = storedOptions ? JSON.parse(storedOptions) : [];

  const handleLogout = () => {
    const token = localStorage.getItem('token');
    if (token) { logout(token).catch(() => {}); }
    localStorage.clear();
    try { sessionStorage.setItem('justLoggedOut','true'); sessionStorage.removeItem('loginRedirectMessage'); } catch (e) { }
    navigate('/');
  };

  useEffect(() => {
    if (localStorage.getItem('token') === null) {
      navigate('/');
    }
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      navigate('/');
    }
    const escolaData = localStorage.getItem('escola');
    if (escolaData) {
      setEscola(JSON.parse(escolaData));
    }
    const vinculoData = localStorage.getItem('vinculo');
    if (vinculoData) {
      setVinculo(JSON.parse(vinculoData));
    }
  }, [navigate]);

  useEffect(() => {
    setInputAno(parseInt(anoBase, 10) || new Date().getFullYear());
  }, [anoBase]);

  if (!user) {
    return <div>Loading...</div>;
  }

  const MIN_YEAR = 2023;
  const MAX_YEAR = new Date().getFullYear();
  const clampYear = (y) => Math.max(MIN_YEAR, Math.min(MAX_YEAR, y));

  const changeAno = (delta) => {
    const current = parseInt(localStorage.getItem('ano') || MAX_YEAR, 10);
    const newYear = clampYear(current + delta);
    localStorage.setItem('ano', String(newYear));
    localStorage.setItem('anoBase', String(newYear));
    setAnoBase(String(newYear));
    setInputAno(newYear);
    window.location.reload();
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-dark fixed-top shadow-sm"
        style={{
          background: 'linear-gradient(90deg, #198754, #146c43)',
        }}
      >
        <div className="container-fluid">
          {/* Hamburger mobile */}
          <button
            className="btn text-white d-lg-none me-2 p-1"
            onClick={toggleSidebar}
            style={{ fontSize: '1.2rem', lineHeight: 1 }}
          >
            <i className="bi bi-list"></i>
          </button>

          {/* Logo + info escola */}
          <a href="/home" className="d-flex align-items-center navbar-brand">
            <img
              src="/assets/logo.png"
              alt="Logo"
              width="120"
              height="40"
              className="d-inline-block align-top me-2 rounded-0"
            />
          </a>
          <div className="d-none d-lg-flex align-items-center" style={{ minWidth: 'max-content', whiteSpace: 'nowrap', flexWrap: 'nowrap' }}>
            <span className="text-white-50 me-2" style={{ fontSize: '1em', lineHeight: 1 }}>|</span>
              <div className="d-flex flex-column" style={{ whiteSpace: 'nowrap' }}>
              {escola?.nome && (
                <span className="nav-link p-0 text-white" style={{ fontSize: '0.85em', lineHeight: 1, marginBottom: '2px' }}>
                  {escola.nome}
                </span>
              )}
              {escola?.municipio && escola?.uf && (
                <span className="nav-link p-0 text-white" style={{ fontSize: '0.7em', lineHeight: 1 }}>
                  {escola.municipio}/{escola.uf}
                </span>
              )}
            </div>
            <span className="text-white-50 mx-2" style={{ fontSize: '1em', lineHeight: 1 }}>|</span>
            <div className="input-group input-group-sm" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
              <button
                type="button"
                className="input-group-text"
                onClick={() => changeAno(-1)}
                aria-label="Ano anterior"
                style={{ cursor: 'pointer', backgroundColor: '#198754', color: '#fff', borderColor: '#198754' }}
              >
                <i className="bi bi-chevron-left" />
              </button>
              <input
                type="text"
                inputMode="numeric"
                className="input-group-text text-center"
                style={{ width: '60px', backgroundColor: '#198754', color: '#fff', borderColor: '#198754' }}
                value={inputAno}
                readOnly
                aria-label="Ano base"
              />
              <button
                type="button"
                className="input-group-text"
                onClick={() => changeAno(1)}
                aria-label="Próximo ano"
                style={{ cursor: 'pointer', backgroundColor: '#198754', color: '#fff', borderColor: '#198754' }}
              >
                <i className="bi bi-chevron-right" />
              </button>
            </div>
          </div>

          {/* Lado direito */}
          <div className="ms-auto d-flex align-items-center">
            {/* Desktop: nome + role do usuário */}
            <div className="d-none d-lg-flex flex-column align-items-end me-2" style={{ minWidth: 'max-content' }}>
              {user?.nome && (
                <span className="text-white fw-semibold" style={{ fontSize: '0.8em', lineHeight: 1, marginBottom: '2px', letterSpacing: '0.03em' }}>
                  {user.nome}
                </span>
              )}
              {user?.role && (
                <span className="text-white opacity-75" style={{ fontSize: '0.6em', lineHeight: 1 }}>
                  {user.role}
                </span>
              )}
            </div>

            {/* Desktop: dropdown do usuário */}
            <div className="nav-item dropdown d-none d-lg-flex">
              <button
                className="nav-link dropdown-toggle text-white d-flex align-items-center border-0 bg-transparent p-0"
                id="userDropdownDesktop"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ cursor: 'pointer' }}
              >
                <i className="bi bi-person-circle fs-4"></i>
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end text-white border-0"
                aria-labelledby="userDropdownDesktop"
                style={{
                  minWidth: '220px',
                  background: 'linear-gradient(135deg, #198754, #146c43)',
                }}
              >
                {Array.isArray(parsedOptions) && parsedOptions.length > 1 && (
                  <li>
                    <a className="dropdown-item text-white" href="/seleciona_escola">
                      <i className="bi bi-arrow-left-right me-2"></i>
                      Trocar Escola
                    </a>
                  </li>
                )}
                <li>
                  <button
                    className="dropdown-item text-white"
                    onClick={() => setShowChangePassword(true)}
                  >
                    <i className="bi bi-key me-2"></i>
                    Alterar senha
                  </button>
                </li>
                <li><hr className="dropdown-divider bg-white mx-2" /></li>
                <li>
                  <button
                    className="dropdown-item text-white"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Sair
                  </button>
                </li>
              </ul>
            </div>

            {/* Mobile: dropdown do usuário (toggler como botão) */}
            <div className="nav-item dropdown d-flex d-lg-none">
              <button
                className="nav-link dropdown-toggle text-white d-flex align-items-center border-0 bg-transparent p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ cursor: 'pointer' }}
              >
                <i className="bi bi-person-circle fs-5"></i>
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end text-white border-0"
                style={{
                  minWidth: '220px',
                  background: 'linear-gradient(135deg, #198754, #146c43)',
                }}
              >
                <li>
                  <div className="px-3 py-2">
                    {user?.nome && (
                      <div className="text-white fw-semibold" style={{ fontSize: '0.85em' }}>{user.nome}</div>
                    )}
                    {user?.role && (
                      <div className="text-white opacity-75" style={{ fontSize: '0.65em', marginTop: '2px' }}>
                        <i className="bi bi-person-badge me-1"></i>{user.role}
                      </div>
                    )}
                  </div>
                </li>
                <li><hr className="dropdown-divider bg-white mx-2" /></li>
                <li className="px-3 py-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="text-white me-2" style={{ fontSize: '0.8em' }}>Ano Base</span>
                    <div className="input-group input-group-sm" style={{ width: 'auto' }}>
                      <button type="button" className="input-group-text" onClick={() => changeAno(-1)} style={{ cursor: 'pointer', backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>
                        <i className="bi bi-chevron-left" />
                      </button>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="input-group-text text-center"
                        style={{ width: '50px', backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}
                        value={inputAno}
                        readOnly
                      />
                      <button type="button" className="input-group-text" onClick={() => changeAno(1)} style={{ cursor: 'pointer', backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>
                        <i className="bi bi-chevron-right" />
                      </button>
                    </div>
                  </div>
                </li>
                <li><hr className="dropdown-divider bg-white mx-2" /></li>
                {Array.isArray(parsedOptions) && parsedOptions.length > 1 && (
                  <li>
                    <a className="dropdown-item text-white" href="/seleciona_escola">
                      <i className="bi bi-arrow-left-right me-2"></i>
                      Trocar Escola
                    </a>
                  </li>
                )}
                <li>
                  <button
                    className="dropdown-item text-white"
                    onClick={() => setShowChangePassword(true)}
                  >
                    <i className="bi bi-key me-2"></i>
                    Alterar senha
                  </button>
                </li>
                <li><hr className="dropdown-divider bg-white mx-2" /></li>
                <li>
                  <button
                    className="dropdown-item text-white"
                    onClick={handleLogout}
                  >
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Sair
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <DefaultModal {...setDefaultModal} />
      <ChangePasswordModal show={showChangePassword} onClose={() => setShowChangePassword(false)} />
    </>
  );
}

export default Navbar;
